export default __webpack_public_path__ + "static/media/p4-3.7cbbdec1.png";